import React, { useState } from 'react';
import WorkspacesOutlined from '@mui/icons-material/WorkspacesOutlined';

export default function WorkspaceBanner({ onCreateClick, onJoinClick }) {
  const [createHover, setCreateHover] = useState(false);
  const [joinHover, setJoinHover] = useState(false);

  return (
    <div
      style={{
        backgroundColor: '#2a2a2a',
        border: '1px solid rgba(57, 255, 20, 0.2)',
        borderRadius: '8px',
        padding: '32px',
        marginBottom: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 16px rgba(0,0,0,0.3), 0 0 40px rgba(57, 255, 20, 0.06)',
      }}
    >
      {/* Left side */}
      <div>
        <WorkspacesOutlined style={{ fontSize: 40, color: '#39FF14', marginBottom: '12px', display: 'block' }} />
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 700,
            fontSize: '20px',
            color: '#FFFFFF',
            marginBottom: '8px',
          }}
        >
          Welcome to Vance
        </div>
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 300,
            fontSize: '15px',
            color: '#888888',
            maxWidth: '480px',
            lineHeight: 1.5,
          }}
        >
          You're not part of a workspace yet. Create your first workspace or join an existing one with an invite code.
        </div>
      </div>

      {/* Right side buttons */}
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <button
          onMouseEnter={() => setCreateHover(true)}
          onMouseLeave={() => setCreateHover(false)}
          onClick={onCreateClick}
          style={{
            backgroundColor: createHover ? '#8B1C26' : '#BF2634',
            color: '#FFFFFF',
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 500,
            fontSize: '14px',
            padding: '12px 24px',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease',
            whiteSpace: 'nowrap',
          }}
        >
          Create Workspace
        </button>
        <button
          onMouseEnter={() => setJoinHover(true)}
          onMouseLeave={() => setJoinHover(false)}
          onClick={onJoinClick}
          style={{
            backgroundColor: 'transparent',
            border: `1px solid ${joinHover ? '#F5F5F5' : '#565656'}`,
            color: '#F5F5F5',
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 500,
            fontSize: '14px',
            padding: '12px 24px',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'border-color 0.15s ease',
            whiteSpace: 'nowrap',
          }}
        >
          Join with Invite Code
        </button>
      </div>
    </div>
  );
}
